// extracted by mini-css-extract-plugin
export default {"fileUploadSection":"IVRProduct_fileUploadSection__LuAvb"};